// PayPal
jQuery(document).ready(function(){

    var $j = jQuery;

    $j('.paypal-form .alert').hide();

    $j('.paypal-form').each(function() {
        $j(this).submit(function() {
            var amt = '0';
            var isAmtChecked = 0;

            if ($j(this).hasClass('paypal-form-simple')) {
                amt = $j(this).find('input[name=amount]').val() || '0';
            } else {
                amt = $j(this).find('input:radio[name=amount]:checked').val() || '0';
                isAmtChecked = $j(this).find('input:radio[name=amount]:checked').length;
            }
            // console.log('originally got '+amt);
            amt = amt.replace(/[^0-9\.]/g, '');
            // console.log('after replace i got: '+amt);
            amt = parseInt(amt);
            // console.log('i got: '+amt);
            if (isNaN(amt)) {
                amt = 0;
            }
            // console.log('i now see: '+amt);

            if (!amt > 0 && !isAmtChecked) {
                $j(this).children('.alert').slideDown();
                var target = $j(this).children('.alert').offset().top;
                $j('html,body').animate({scrollTop: target}, 1000);
                return false;
            }
            if ($j(this).hasClass('paypal-form-simple')) {
                $j(this).find('input[name=amount]').val(amt);
            }
            return true;
        });
    });

});
